import React from "react";

// SVG component for a stylized vial with label
export const VialImage = ({ label, className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      <svg
        viewBox="0 0 120 200"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Vial cap/stopper */}
        <rect
          x="35"
          y="5"
          width="50"
          height="15"
          rx="3"
          fill="hsl(var(--primary))"
          opacity="0.9"
        />
        
        {/* Cap rim */}
        <rect
          x="30"
          y="18"
          width="60"
          height="8"
          rx="2"
          fill="hsl(var(--primary))"
          opacity="0.7"
        />
        
        {/* Vial neck */}
        <path
          d="M40 26 L40 45 Q40 50 35 55 L35 55"
          fill="none"
          stroke="hsl(var(--muted-foreground))"
          strokeWidth="1"
          opacity="0.3"
        />
        <path
          d="M80 26 L80 45 Q80 50 85 55 L85 55"
          fill="none"
          stroke="hsl(var(--muted-foreground))"
          strokeWidth="1"
          opacity="0.3"
        />
        
        {/* Vial body - glass effect */}
        <rect
          x="25"
          y="50"
          width="70"
          height="130"
          rx="8"
          fill="white"
          stroke="hsl(var(--border))"
          strokeWidth="1.5"
        />
        
        {/* Glass reflection effect */}
        <rect
          x="30"
          y="55"
          width="8"
          height="100"
          rx="4"
          fill="white"
          opacity="0.6"
        />
        
        {/* Liquid inside vial */}
        <rect
          x="28"
          y="100"
          width="64"
          height="76"
          rx="6"
          fill="hsl(var(--primary))"
          opacity="0.15"
        />
        
        {/* Label background */}
        <rect
          x="32"
          y="60"
          width="56"
          height="35"
          rx="3"
          fill="white"
          stroke="hsl(var(--primary))"
          strokeWidth="1"
        />
        
        {/* Label text */}
        <text
          x="60"
          y="82"
          textAnchor="middle"
          fontSize="12"
          fontWeight="600"
          fontFamily="Space Grotesk, sans-serif"
          fill="hsl(var(--primary))"
        >
          {label}
        </text>
        
        {/* Small detail lines on label */}
        <line
          x1="38"
          y1="68"
          x2="82"
          y2="68"
          stroke="hsl(var(--primary))"
          strokeWidth="0.5"
          opacity="0.3"
        />
        <line
          x1="45"
          y1="88"
          x2="75"
          y2="88"
          stroke="hsl(var(--primary))"
          strokeWidth="0.5"
          opacity="0.3"
        />
      </svg>
    </div>
  );
};

export default VialImage;
